<template>
  <div id="publishing-affiliations-add">
    <ipub-model :title="'Edit Affiliations'"
                width="900px"
                :visable="isVisable"
                :confirmText="params.id?'Save':'Add'"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-form ref="affiliations-add-form"
                 :model="params"
                 :rules="rules">
        <ipub-form-item prop="content"
                        label="Affiliations">
          <ipub-input placeholder="Affiliations"
                      v-model.trim="params.content" />
        </ipub-form-item>
      </ipub-form>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      params: {},
      rules: {},
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      journalId: 'getJournalId',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {}
      } else {
        this.params = Object.assign(this.params, this.inputData)
        if (this.params.name) {
          this.params.content = this.params.name + ', ' + this.params.country
        }
      }
    }
  },
  mounted () {
    this.getRules()
  },
  methods: {
    async confirm () {
      const flag = this.$refs['affiliations-add-form'].validate()
      if (flag) {
        let arr = this.params.content.split(', ')
        this.params.country = arr.pop()
        this.params.name = arr.join(', ')
        delete this.params.content
        this.$message.success({ title: 'Success', content: 'This Affiliations has been saved!' })
        this.$emit('confirm', this.params)
      }
    },
    preview () {

    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        content: [
          {
            required: true,
            message:
              'Affiliation' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
